import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { SignupsTable } from "@/components/admin/SignupsTable";

import { API } from "@/lib/api";
const http = axios.create({ baseURL: API, withCredentials: true });

export default function Admin() {
  const [authed, setAuthed] = useState(null);
  const [data, setData] = useState({ total: 0, items: [] });

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    document.title = "Admin — Astralsand";
    return () => meta.remove();
  }, []);

  const load = useCallback(async () => {
    try {
      const res = await http.get("/admin/signups");
      setData(res.data);
      setAuthed(true);
    } catch {
      setAuthed(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    try {
      await http.delete(`/admin/signups/${id}`);
    } finally {
      load();
    }
  };

  const logout = async () => {
    await http.post("/admin/logout");
    setAuthed(false);
  };

  if (authed === null) return <div className="adm" data-testid="admin-loading">Loading…</div>;
  if (!authed) return <AdminLogin http={http} onSuccess={load} />;
  return <SignupsTable data={data} onDelete={remove} onLogout={logout} exportUrl={`${API}/admin/export`} />;
}
